import { render, staticRenderFns } from "./SolarProductionModule.vue?vue&type=template&id=845c7080&scoped=true"
import script from "./SolarProductionModule.vue?vue&type=script&lang=js"
export * from "./SolarProductionModule.vue?vue&type=script&lang=js"
import style0 from "./SolarProductionModule.vue?vue&type=style&index=0&id=845c7080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845c7080",
  null
  
)

export default component.exports